import React /*, { useEffect, useState } */ from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';

const Loading = (props) => {
  // let timeout = null;
  // const [showLoader, setShowLoader] = useState(false);
  // timeout = setTimeout(() => {
  //   setShowLoader(true);
  // }, props.timeout);
  // useEffect(() => {
  //   return () => {
  //     clearTimeout(timeout);
  //   };
  // });
  // if (!showLoader) return null;
  return ReactDOM.createPortal(
      <div onClick={(ev) => { ev.preventDefault(); ev.stopPropagation(); }} className="loading-container" title="7">
        <div className="loading">
          <svg version="1.1" id="Layer_1" x="0px" y="0px"
              width="24px" height="30px" viewBox="0 0 24 30" style={{enableBackground: "new 0 0 50 50"}}>
            <rect x="0" y="10" width="4" height="10" fill="#333" opacity="0.2">
              <animate attributeName="opacity" attributeType="XML" values="0.2; 1; .2" begin="0s" dur="0.6s"
                      repeatCount="indefinite"/>
              <animate attributeName="height" attributeType="XML" values="10; 20; 10" begin="0s" dur="0.6s"
                      repeatCount="indefinite"/>
              <animate attributeName="y" attributeType="XML" values="10; 5; 10" begin="0s" dur="0.6s"
                      repeatCount="indefinite"/>
            </rect>
            <rect x="8" y="10" width="4" height="10" fill="#333" opacity="0.2">
              <animate attributeName="opacity" attributeType="XML" values="0.2; 1; .2" begin="0.15s" dur="0.6s"
                      repeatCount="indefinite"/>
              <animate attributeName="height" attributeType="XML" values="10; 20; 10" begin="0.15s" dur="0.6s"
                      repeatCount="indefinite"/>
              <animate attributeName="y" attributeType="XML" values="10; 5; 10" begin="0.15s" dur="0.6s"
                      repeatCount="indefinite"/>
            </rect>
            <rect x="16" y="10" width="4" height="10" fill="#333" opacity="0.2">
              <animate attributeName="opacity" attributeType="XML" values="0.2; 1; .2" begin="0.3s" dur="0.6s"
                      repeatCount="indefinite"/>
              <animate attributeName="height" attributeType="XML" values="10; 20; 10" begin="0.3s" dur="0.6s"
                      repeatCount="indefinite"/>
              <animate attributeName="y" attributeType="XML" values="10; 5; 10" begin="0.3s" dur="0.6s"
                      repeatCount="indefinite"/>
            </rect>
          </svg>
        </div>
      </div>
    , document.body)

};

Loading.propTypes = {
  timeout: PropTypes.number,
};

Loading.defaultProps = {
  timeout: 500,
};

export default Loading;



// WEBPACK FOOTER //
// ./src/components/elements/Loading.js